// extracted by mini-css-extract-plugin
module.exports = {"photosPreviewRow":"styles_photosPreviewRow__1lh0K","photosPreviewImageWrapper":"styles_photosPreviewImageWrapper__3_29C"};